import module from './index'

let moduleName = 'module->' + module.info.name;
const routes = [
    {
        path: module.info.name,
        name: moduleName,
        component: () => import('./View.vue'),
        children: [
            {
                path: 'create',
                name: moduleName + '->create',
                component: () => import('./create/View'),
            },
            {
                path: 'history',
                name: moduleName + '->history',
                component: () => import('./history/View'),
            },
            {
                path: 'automation',
                name: moduleName + '->automation',
                component: () => import('./automation/View'),
            },
            {
                path: 'list',
                name: moduleName + '->list',
                component: () => import('./list/View'),
                children: [
                    {
                        path: ':listPage',
                        name: moduleName + '->list->page',
                        component: () => import('./list/page/View'),
                    }
                ]
            },
        ]
    }
];

export default routes
